import React, {useMemo}								from 'react';

import Icon 										from '../Icon';
import ProgressBar									from '../ProgressBar/ProgressBar';

import img_upload									from '../../images/icon/upload.svg';
import img_close									from '../../images/icon/close.svg';

import {NotificationCardProps}						from './interface';

import './NotificationCard.css';


const defaultProps: NotificationCardProps = {
	type:    'success',
	icon:    img_upload,
	title:   '',
	text:    ''
};

function NotificationCard(props: NotificationCardProps): JSX.Element {
	props = {...defaultProps, ...props};

	const renderText: React.ReactElement[] = useMemo(
		() => {
			const render: React.ReactElement[] = [];

			if (typeof props.text === 'string')
				render.push(<span>{props.text}</span>);
			else {
				props.text?.forEach(each =>
					render.push(<span className={each.className}>{each.text}</span>)
				);
			}
			return render;
		},
		[props.text]
	);

	const className = `${props.type}-100-background ${props.type}-50-border`;
	let iconColor = '#039855';

	if (props.type === 'error')
		iconColor = '#D92D20';
	if (props.type === 'primary')
		iconColor = '#6938EF';

	return (
		<div key={`notification-${props.key}`} className={`notificationCard ${renderText.length === 0 && 'titleOnly'}`}>
			<Icon
				size={32}
				iconBorder
				iconSize={20}
				borderSize={6}
				icon={props.icon}
				className={className}
				iconColor={[iconColor, iconColor]}
			/>
			<div className={'notificationCardText'}>
				<span>{props.title}</span>
				<span>{renderText}</span>
				{props.percent !== undefined &&
					<div className={'notificationProgress'}>
						<ProgressBar value={props.percent} />
						<span>{`${props.percent}%`}</span>
					</div>
				}
			</div>
			<Icon
				onClick={props.onClick}
				icon={img_close}
				iconSize={10}
				iconColor={'#667085'}
			/>
		</div>
	);
}


export default NotificationCard;